/**
 * Vanilla version of jquery param().
 * Turns an object of parameters into a url parameter string.
 * @param params url parameters as key value pairs.
 */

const param = (params: object): string => {
  if (params == null) return '';
  return new URLSearchParams(Object.entries(params)).toString();
};

export default param;
